module.exports = __webpack_public_path__ + "img/cloth_g1_pants_04.15e1e92b.svg";